import { ContactForm } from "./ContactForm";
import { Mail, MapPin, Clock } from "lucide-react";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div
        className="absolute inset-0 -z-10 opacity-60"
        style={{
          background:
            "radial-gradient(ellipse 50% 40% at 80% 0%, rgba(124,58,237,0.18), transparent 70%)",
        }}
        aria-hidden
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-5">
            <div className="text-xs font-mono-ui uppercase tracking-[0.28em] text-violet-400 mb-4">
              ─── Book an Assessment
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[56px] font-light tracking-tighter text-zinc-50 leading-[1.02]">
              Let’s pressure-test
              <br />
              <span className="text-zinc-500">your GTM.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed max-w-md">
              Tell us about your motion. We’ll respond within one business day
              with a short brief on where we’d start and what we’d skip.
            </p>

            <div className="mt-10 space-y-5 border-t border-white/5 pt-8">
              {[
                { icon: Mail, k: "Direct", v: "chris@catlyz.co" },
                { icon: Clock, k: "Response", v: "Within 24 hours, Mon–Fri" },
                { icon: MapPin, k: "Operating", v: "Remote · Global" },
              ].map((row) => {
                const Icon = row.icon;
                return (
                  <div key={row.k} className="flex items-start gap-4">
                    <span className="mt-1 inline-flex h-8 w-8 items-center justify-center border border-white/10">
                      <Icon className="h-3.5 w-3.5 text-violet-300" strokeWidth={1.6} />
                    </span>
                    <div>
                      <div className="text-[11px] font-mono-ui uppercase tracking-[0.22em] text-zinc-500">
                        {row.k}
                      </div>
                      <div className="text-sm text-zinc-100">{row.v}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="md:col-span-7">
            <div className="border border-white/10 bg-zinc-950/70 backdrop-blur-md p-6 md:p-10">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
